<template>

  <div id="app">
    <!-- start wallkit spinner -->
    <div class="wallkit-spinner" v-show="spinner">
      <div class="wallkit-spinner__container">
        <div class="cube1"></div>
        <div class="cube2"></div>
      </div>
    </div>
    <!-- end wallkit spinner -->

    <div id="wallkit-content" v-resize:throttle="resizeContent">
      <router-view/>
    </div>
  </div>

</template>

<style lang="scss">
$fa-font-path: '~font-awesome/fonts/';
@import '~font-awesome/scss/font-awesome.scss';
@import 'assets/css/main.scss';
@import 'firebaseui/dist/firebaseui.css';
</style>


<script>
import {EventBus} from './utils/event-bus';
import store from "./store";
import Wallkit from './plugins/wallkit.esm.min';
import WkMethods from './extension/methods.js';
import resize from 'vue-resize-directive';
import debug from "./utils/debug";

export default {
  data() {
    return {
      spinner: true,
      user: null,
      resource: null
    }
  },
  directives: {
    resize
  },
  mixins: [WkMethods],
  created() {
    this.event("wk-event-storage-available", Wallkit.isLocalStorageAvailable);

    this.spinner = true;
    this.user = store.getters['user/user'];
    this.resource = store.getters['resource/resource'];
  },
  methods: {
    onMessage() {

      if (event &&
        typeof event === "object" &&
        typeof event.data === "object" &&
        typeof event.data.name !== "undefined" &&
        typeof event.data.value !== "undefined") {

        switch (event.data.name) {

          case "wk-event-modal" :
            if (event.data.value) {
              if (typeof event.data.params !== "undefined" && typeof event.data.params === "object") {

                if (event.data.value.charAt(0) !== "/") {
                  event.data.value = "/" + event.data.value
                }

                this.$router.replace({path: event.data.value, query: event.data.params});
              } else {
                this.$router.replace(event.data.value);
              }
              this.resize(true);
            } else {
              this.$router.replace("/");
            }
            break;

          case "wk-event-firebase-token" :
            Wallkit.setFirebaseToken(event.data.value);
            break;

          case "wk-event-token" :
            Wallkit.setToken(event.data.value);
            store.dispatch('auth/updateToken', {token: event.data.value, remember: true});
            break;

          case "wk-event-logout" :
            if (this.$firebase) {
              this.$firebase.auth().signOut().then(() => {
                this.$firebase.removeSavedAccountFromStorage();
                debug.log('FIREBASE LOGGED OUT');
              }).catch(function(error) {
                debug.log('FIREBASE LOG OUT FAILED:', error);
              });
            }

            break;

          case "wk-event-auth" :
            Wallkit.authUserByToken(event.data.value.token);
            break;

          case "wk-event-one-tap-sign-in" :
            if (this.$firebase) {
              let credential = this.$firebase.auth.GoogleAuthProvider.credential(event.data.value);

              this.$firebase.auth().signInWithCredential(credential).then(({user}) => {
                user.getIdToken().then((token) => {
                  Wallkit.authenticateWithFirebase(token).then((response) => {
                    if (response) {
                      if (response.existed) {
                        this.event('wk-firebase-onetap-signin', true);
                      } else {
                        this.event('wk-firebase-onetap-signup', true);
                      }
                    }
                  });
                });
              });
            }

            break;

          case "wk-event-firebase-custom-token" :

            if (this.$firebase) {
              this.$firebase.auth().signInWithCustomToken(event.data.value).then(({user}) => {
                user.getIdToken().then((token) => {
                  Wallkit.authenticateWithFirebase(token);
                });
              });
            }

            break;

          case "wk-event-transaction" :
            //Wallkit.getUser();
            break;

          case "wk-event-applepay-ready" :
            store.dispatch('options/availableApplePay', event.data.value);
            break;

          case "wk-event-close-modal" :
            EventBus.$emit('wk-on-modal-close');
            break;

          case "wk-event-parent-page" :
            store.dispatch('resource/updateParentPage', event.data.value);
            break;

        }
      }
    },
    toggleLoader(state) {
      this.spinner = typeof state === 'undefined' ? !this.spinner : state;
    },
    handleRouteChange(from, to) {
      this.clearPromo();
    },
  },
  mounted() {

    setTimeout(() => {
      this.event("wk-event-modals-ready", true);
      window.addEventListener("message", this.onMessage);
    });

    EventBus.$on('wk-lazy-comp-ready', (value) => {
      this.toggleLoader(!value);
    });

    EventBus.$on('wk-loader', (value) => {
      this.toggleLoader(value);
    });


    let firebaseListener = () => {
      this.$firebase.auth().onIdTokenChanged((user) => {
        if (user) {
          user.getIdToken().then((token) => {
            if (token)  {
              Wallkit.setFirebaseToken(token);

              Wallkit.verifyFirebaseToken().then((status) => {
                if (status) {
                  this.event('wk-firebase-token', token);
                } else {
                  this.logoutFromFirebase();
                }
              }).catch((error) => {
                this.logoutFromFirebase();
                debug.log('ERROR:', error);
              })
            }
          });
        }
      });
    };

    if (!this.$firebase) {
      EventBus.$on('firebase-init', () => {
        firebaseListener();
      });
    } else {
      firebaseListener();
    }
  },
  watch: {
    $route(to, from) {
      this.event("wk-event-route-change", to.params.template);
      this.handleRouteChange(from, to);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue